export const state = {
  products: {},
  categories: [],
  sideMenu: [],
}

export const mutations = {
  updateProductList(state, payload) {
    state.products = payload
  },

  updateCategoryList(state, payload) {
    state.categories = payload
  },

  updateSideMenuList(state, payload) {
    state.sideMenu = payload
  },
}
